import axios from "axios";
import { API_URL } from "./constants";
import { PATH } from "./enums";
import { auth } from "./firebase";

const baseURL = API_URL;

const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
  validateStatus(status) {
    return status < 300; // || status === 403; // Resolve only if the status code is less than 500
  },
});

api.interceptors.request.use(async (config) => {
  // const { user } = useAuth();
  try {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
  } catch (error) {
    console.error("Error obtaining auth token in interceptor");
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status === 401 && // TODO remove
      window.location.pathname !== PATH.LOGIN
    ) {
      if (auth.currentUser) {
        const token = await auth.currentUser.getIdToken(true);
        localStorage.setItem("token", token);

        originalRequest.headers["Authorization"] = "Bearer " + token;
        return api(originalRequest); // Retry request
      } else {
        window.location.href = "/login";
      }
      // window.location.reload()
    }
    return Promise.reject(error);
  },
);

export default api;
